import React from 'react'
import { Card } from 'react-bootstrap'
import NotificationList from './NotificationList'
import { useSelector } from 'react-redux'

export default function Notification() {
  const admin = useSelector((state) => state.admin)
  return (
    <>
      <Card>
        <Card.Header>
          <span>Notifications</span>
        </Card.Header>
        <Card.Body>
          <Card.Title>รายการแจ้งเตือน</Card.Title>
          <Card.Subtitle>รายละเอียดการแจ้งเตือนที่ยังไม่ได้อ่าน</Card.Subtitle>
          <div className="pt-3 pb-3">
            <NotificationList notifications={admin.announcements ? admin.announcements : []} />
          </div>
        </Card.Body>
      </Card>
    </>
  )
}
